import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProductsBidding } from "../../redux/actions";
import { TableHead, TableRow, TableCell, Table, TableBody, TableSortLabel, TablePagination, makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import SyncLoader from "react-spinners/SyncLoader";
import { css } from "@emotion/react";
import { getCategory, getSubcategory } from "../../redux/actions";

const MyBiddingListing = (props) => {

    const dispatch = useDispatch();
    const products = useSelector((state) => state.productDetails.bidding);
    const [loading, setLoading] = useState(false);
    const category = useSelector((state) => state.categoryDetail.categories);
    const subcategory = useSelector((state) => state.subCategoryDetail.subCategories);
    // const [idList, setIdList] = useState([])
    // const [disableDelete, setDisableDelete] = useState(true);
    const [shareModal, toggleShareModal] = useState(false);
    const [shareUrl, setShareUrl] = useState("")
    const [shareCode, setSharedCode] = useState("")
    const [search, setsearch] = useState("")
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [searchflag, setsearchflag] = useState(false)
    const [color, setColor] = useState("#000000");
    const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;

    useEffect(() => {
        setLoading(true)
        dispatch(getCategory());
        dispatch(getSubcategory());
        const callback = () => {
            setLoading(false);
        }
        dispatch(getProductsBidding(callback));
    }, [])

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = event => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    // setIsSubmitting(true);
    // const callback = () => setIsSubmitting(false);
    // { values: initialValues, callback }

    // useEffect(() => {
    //     // setIdList([]);
    //     const checkAllInput = document.getElementById("checkAllInput");
    //     if (checkAllInput.checked)
    //         checkAllInput.checked = false;
    // }, [searchflag])

    useEffect(() => {
        setPage(0);
        if (search === "") { setsearchflag(false) }
        else { setsearchflag(true) }
    }, [search])

    // useEffect(() => {
    //     const filteredProducts = products && products.filter(product => product.title.toLowerCase().includes(search.toLowerCase()) || (product.sellerName && product.sellerName.toLowerCase().includes(search.toLowerCase())) || product.buyNowPrice.toLowerCase().includes(search.toLowerCase()) || product.minimumOfferPrice.toLowerCase().includes(search.toLowerCase())).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    //     if (idList.length ? idList.length === products.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).length || idList.length === filteredProducts.length : false) {
    //         const checkAllInput = document.getElementById("checkAllInput");
    //         if (!checkAllInput.checked)
    //             checkAllInput.checked = true;
    //     }
    // }, [idList])

    var defaultSortBy = "createdAt";
    var defaultSortOrder = "desc";
    let [sortBy, setsortBy] = useState(defaultSortBy)             // default sort column
    let [sortOrder, setsortOrder] = useState(defaultSortOrder)    // default sort order

    const sortData = (sortBy, sortOrder, rows) => {
        var itemsToSort = JSON.parse(JSON.stringify(rows || products));
        var sortedItems = [];
        var compareFn = null;
        switch (sortBy) {
            case "createdAt":
                compareFn = (i, j) => {

                    if (i.createdAt < j.createdAt) {
                        return sortOrder === "desc" ? 1 : -1;
                    } else {
                        if (i.createdAt > j.createdAt) {
                            return sortOrder === "desc" ? -1 : 1;
                        }
                        else {
                            return 0;
                        }
                    }
                };
                break;
            case "title":
                compareFn = (i, j) => {

                    if (i.title < j.title) {
                        return sortOrder === "asc" ? -1 : 1;
                    } else {
                        if (i.title > j.title) {
                            return sortOrder === "asc" ? 1 : -1;
                        }
                        else {
                            return 0;
                        }
                    }
                };
                break;
            case "category":
                console.log('yes its run')
                compareFn = (i, j) => {

                    if (i.title < j.title) {
                        return sortOrder === "asc" ? -1 : 1;
                    } else {
                        if (i.title > j.title) {
                            return sortOrder === "asc" ? 1 : -1;
                        }
                        else {
                            return 0;
                        }
                    }

                };
                break;
            case "subcategory":
                compareFn = (i, j) => {
                    if (i.title < j.title) {
                        return sortOrder === "asc" ? -1 : 1;
                    } else {
                        if (i.title > j.title) {
                            return sortOrder === "asc" ? 1 : -1;
                        }
                        else {
                            return 0;
                        }
                    }
                };
                break;

            case "price":
                compareFn = (i, j) => {
                    if (parseFloat(i.buyNowPrice) < parseFloat(j.buyNowPrice)) {
                        //   return -1;
                        return sortOrder === "asc" ? -1 : 1;
                    } else {
                        if (parseFloat(i.buyNowPrice) > parseFloat(j.buyNowPrice)) {
                            // return 1;
                            return sortOrder === "asc" ? 1 : -1;
                        }
                        else {
                            return 0;
                        }
                    }
                };
                break;

            case "minimumoffer":
                compareFn = (i, j) => {
                    if (parseFloat(i.minimumOfferPrice) < parseFloat(j.minimumOfferPrice)) {
                        // return -1;
                        return sortOrder === "asc" ? -1 : 1;
                    }
                    else {
                        if (parseFloat(i.minimumOfferPrice) > parseFloat(j.minimumOfferPrice)) {
                            // return 1;
                            return sortOrder === "asc" ? 1 : -1;
                        }
                        else {
                            return 0;
                        }
                    }
                };
                break;


            case "totaloffer":
                compareFn = (i, j) => {
                    if (parseInt(i.productBidders.length) < parseInt(j.productBidders.length)) {
                        return -1;
                    }
                    else {
                        if (parseInt(i.productBidders.length) > parseInt(j.productBidders.length)) {
                            return 1;
                        }
                        else {
                            return 0;
                        }
                    }
                };
                break;

            //   case "bmonth":
            //     compareFn = (i, j) => {
            //       var indexOfI = monthMap.indexOf(i.bmonth);
            //       var indexOfJ = monthMap.indexOf(j.bmonth);
            //       if (indexOfI < indexOfJ) {
            //         return sortOrder === "asc" ? -1 : 1;
            //       } else {
            //         if (indexOfI > indexOfJ) {
            //           return sortOrder === "asc" ? 1 : -1;
            //         } else {
            //           return 0;
            //         }
            //       }
            //     };
            //     break;
            default:
                break;
        }
        console.log(`---->itemtosort${sortBy}`, itemsToSort)
        sortedItems = products ? itemsToSort.sort(compareFn) : '';
        console.log('---->sortItems', sortedItems)
        return sortedItems;
    }

    const requestSort = (pSortBy) => {

        var newsortBy = sortBy;
        var newsortOrder = sortOrder;

        console.log('-->newsortBy', newsortBy)
        console.log('-->newsortOrder', newsortOrder)
        console.log('-->pSortBy', pSortBy)

        return event => {
            if (pSortBy === newsortBy) {
                newsortOrder = newsortOrder === "asc" ? "desc" : "asc";
            } else {
                newsortBy = pSortBy;
                newsortOrder = "asc";
            }

            var sortedItems = sortData(newsortBy, newsortOrder);
            setdata({ ...data, rows: sortedItems })
            setsortBy(newsortBy)
            setsortOrder(newsortOrder)
        };
    }
    useEffect(() => {
        setdata({ ...products, rows: sortedItems })
    }, [products])

    var sortedItems = sortData(defaultSortBy, defaultSortOrder, products);
    const [data, setdata] = useState({ ...products, rows: sortedItems })


    return (
        <>
            <div className="dashContentHeader">
                <h5 className="dashHeading mb-0">My Biddings</h5>
            </div>
            {/* {console.log("Products", products)} */}
            <div className="dashboardCardRow">
                <div className="input-group mb-4 search-menu">
                    <input type="text" className="form-control" onChange={(e) => { setsearch(e.target.value) }} value={search} placeholder="Search Bidding..." />
                    <button className="btn btn-custom-1 reset-button" onClick={() => { setsearch("") }}>
                        <i class="fa fa-refresh" aria-hidden="true"></i> Reset</button>
                    <div className="input-group-append">
                        <span className="input-group-text">
                            <i className="fa fa-search" aria-hidden="true"></i>
                        </span>
                    </div>
                    {/* <button className="btn btn-custom" onClick={() => { setsearch("") }}>
                        <i class="fa fa-refresh" aria-hidden="true"></i> Reset</button> */}
                </div>
                <div className="listingTableRow">
                    <div className="listingTableHeader d-flex flex-wrap justify-content-between align-items-center pb-4 ">
                        <div className="custom-control custom-checkbox">
                            {/* <input type="checkbox" className="custom-control-input" id="checkAllInput" onChange={(event) => {

                                const checkBoxes1 = document.getElementsByClassName("custom-control-input group1");
                                const checkBoxes2 = document.getElementsByClassName("custom-control-input group2");
                                if (event.target.checked) {
                                    for (let checkBox of checkBoxes1) {
                                        if (!checkBox.checked)
                                            checkBox.checked = true;
                                    }
                                    for (let checkBox of checkBoxes2) {
                                        if (!checkBox.checked)
                                            checkBox.checked = true;
                                    }
                                    let tempArray = [];
                                    if (!searchflag) {
                                        products.forEach(product => {
                                            tempArray.push(product._id);
                                        })
                                    }
                                    else {
                                        const filteredProducts = products && products.filter(product => product.title.toLowerCase().includes(search.toLowerCase()));
                                        filteredProducts.forEach(product => {
                                            tempArray.push(product._id);
                                        })
                                    }
                                    setIdList(tempArray);
                                }
                                else {
                                    for (let checkBox of checkBoxes1) {
                                        if (checkBox.checked)
                                            checkBox.checked = false;
                                    }
                                    for (let checkBox of checkBoxes2) {
                                        if (checkBox.checked)
                                            checkBox.checked = false;
                                    }
                                    setIdList([]);
                                }

                            }} /> */}
                            {/* <label className="custom-control-label" for="checkAllInput">Showing {searchflag ? (products && products.filter(product => product.title.toLowerCase().includes(search.toLowerCase()) || (product.sellerName && product.sellerName.toLowerCase().includes(search.toLowerCase())) || product.buyNowPrice.toLowerCase().includes(search.toLowerCase()) || product.minimumOfferPrice.toLowerCase().includes(search.toLowerCase())).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).length) : (products && products.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).length)} products</label> */}
                            <label>Showing {searchflag ? (products && products.filter(product => product.title.toLowerCase().includes(search.toLowerCase()) || (product.sellerName && product.sellerName.toLowerCase().includes(search.toLowerCase())) || product.buyNowPrice.toString().includes(search.toLowerCase()) || product.minimumOfferPrice.toString().includes(search.toLowerCase())).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).length) : (products && products.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).length)} products</label>
                        </div>
                        {/* <div className="d-flex justify-content-between align-items-center">
                            <button className="border-0 deleteButton mr-4">
                                <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.33398 3.66667V2.33333C3.33398 1.97971 3.47446 1.64057 3.72451 1.39052C3.97456 1.14048 4.3137 1 4.66732 1H7.33398C7.68761 1 8.02674 1.14048 8.27679 1.39052C8.52684 1.64057 8.66732 1.97971 8.66732 2.33333V3.66667M10.6673 3.66667V13C10.6673 13.3536 10.5268 13.6928 10.2768 13.9428C10.0267 14.1929 9.68761 14.3333 9.33398 14.3333H2.66732C2.3137 14.3333 1.97456 14.1929 1.72451 13.9428C1.47446 13.6928 1.33398 13.3536 1.33398 13V3.66667H10.6673Z" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M4.66602 7V11" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7.33398 7V11" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Delete
                            </button>
                            <div className="d-flex align-items-center shortListedDropdown">
                                <label className="mb-0">Sort by</label>
                                <div className="dropdown">
                                    <button className="border-0 btn-link dropdown-toggle card-link"
                                        type="button" id="dropdownMenu1" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false">
                                        Newset update
                                    </button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenu1">
                                        <Link className="dropdown-item" to={window.location.pathname}>Action</Link>
                                        <Link className="dropdown-item" to={window.location.pathname}>action2</Link>
                                    </div>
                                </div>
                            </div>

                        </div> */}
                    </div>
                    <div className="table-responsive">
                        <table className="table customDashboardTable  table-width">
                            {/* <tr>
                                <th>Listing Name</th>
                                <th>Category</th>
                                <th>Subcategory</th>
                                <th>Price</th>
                                <th style={{ maxWidth: "100px" }}>Minimum Offer Amount</th>
                                <th style={{ maxWidth: "100px" }}>No. of
                                    Offers</th>
                                <th>Status</th>
                                <th>Seller Info</th>
                                <th>Actions</th>
                            </tr> */}

                            {/* {products && products.map(product => {
                                return <tr>
                                    <td>
                                   
                                        <div className="custom-control custom-checkbox">
                                            <input type="checkbox" className="custom-control-input" id="customCheck2" checked />
                                            <label className="custom-control-label" for="customCheck2">{product.title}</label>
                                        </div>
                                    </td>
                                    <td>{product.categoryObj.name}</td>
                                    <td>{product.subcategoryObj.name}</td>
                                    <td>${product.buyNowPrice}</td>
                                    <td>${product.minimumOfferPrice}</td>
                                    <td>{product.productBidders.length}</td>
                                    <td><button className="btn soldBtn">{product.status}</button></td>
                                    <td>{product.sellerName} </td>
                                  
                                    <td><div className="dropdown">
                                        <button className="btn btn-link dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <svg width="22" height="6" viewBox="0 0 22 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="3" cy="3" r="3" fill="#C4C4C4" />
                                                <circle cx="11" cy="3" r="3" fill="#C4C4C4" />
                                                <circle cx="19" cy="3" r="3" fill="#C4C4C4" />
                                            </svg>
                                        </button>
                                        <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                            <Link className="dropdown-item" to={window.location.pathname}>Edit</Link>
                                            <Link className="dropdown-item" to={window.location.pathname}>Delete</Link>
                                            <Link className="dropdown-item" to={window.location.pathname}>Share</Link>
                                        </div>
                                    </div></td>
                                </tr>
                            })} */}



                            <Table>

                                <TableHead>
                                    <TableRow>

                                        {/* <TableHeaderColumn key={`thc-${i}`}>
                                        <div style={{ display: "flex", alignItems: "center" }} onClick={() => handleSort(x.prop)} >
                                        <span>{x.name}</span>
                                        {columnToSort === x.prop ? (sortDirection === "asc" ? (<UpArrow />) : (<DownArrow /> ) ) : null}
                                        </div> 
                                        </TableHeaderColumn>  */}

                                        <TableCell> <TableSortLabel active={sortBy === "title"} direction={sortOrder} onClick={requestSort("title")}>Listing Name </TableSortLabel> </TableCell>
                                        <TableCell>  Category </TableCell>
                                        <TableCell> Subcategory </TableCell>
                                        <TableCell> <TableSortLabel active={sortBy === "price"} direction={sortOrder} onClick={requestSort("price")}     >Price </TableSortLabel></TableCell>
                                        <TableCell> <TableSortLabel active={sortBy === "minimumoffer"} direction={sortOrder} onClick={requestSort("minimumoffer")} >Minimum Offer Amount </TableSortLabel></TableCell>
                                        <TableCell> <TableSortLabel active={sortBy === "totaloffer"} direction={sortOrder} onClick={requestSort("totaloffer")} >No. of Offers </TableSortLabel></TableCell>
                                        <TableCell> Status </TableCell>
                                        <TableCell> Manage Bids </TableCell>
                                        <TableCell> Seller Info </TableCell>
                                        {/* <TableCell> Actions</TableCell> */}
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {loading &&
                                        (
                                            <TableRow >
                                                <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                                <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                                <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                                <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                                <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                                <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                                <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                                <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                                <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                                {/* <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell> */}

                                            </TableRow>
                                        )}

                                    {!loading && data.rows && data.rows.filter(product => product.title.toLowerCase().includes(search.toLowerCase()) || (product.sellerName && product.sellerName.toLowerCase().includes(search.toLowerCase())) || product.buyNowPrice.toString().includes(search.toLowerCase()) || product.minimumOfferPrice.toString().includes(search.toLowerCase())).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((product, index) => {
                                        const cat = category.find(cat => cat._id == product.categoryId)
                                        const subcat = subcategory.find(cat => cat._id == product.subCategoryId)
                                        return (
                                            <TableRow >
                                                <TableCell>    <div className="custom-control custom-checkbox">
                                                    {/* <input type="checkbox" className="custom-control-input group1" id={`customCheck${index}`} onChange={(event) => {
                                                        if (event.target.checked) {
                                                            setIdList([...idList, product._id]);
                                                        }
                                                        else {
                                                            setIdList(idList.filter(id => id !== product._id));
                                                            const checkAllInput = document.getElementById("checkAllInput");
                                                            if (checkAllInput.checked)
                                                                checkAllInput.checked = false;
                                                        }
                                                    }} /> */}
                                                    <label className="custom-control-label" for={`customCheck${index}`}>{product.title}</label>
                                                </div>
                                                </TableCell>

                                                <TableCell> {cat.name}     </TableCell>
                                                <TableCell> {subcat.name}    </TableCell>
                                                <TableCell> {product.buyNowPrice}   </TableCell>
                                                <TableCell> {product.minimumOfferPrice}     </TableCell>
                                                <TableCell> {product.productBidders.length}     </TableCell>
                                                <TableCell>  <button className="btn soldBtn">{product.status}</button>    </TableCell>
                                                <TableCell>  {product.makeOfferPage && <> <svg class="mr-2" width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.008 23.253H10.8129C10.7154 23.1555 -0.286879 20.2293 0.00573469 3.882V3.64791L1.50782 1.50208L1.80043 1.46307C1.9955 1.42405 11.008 0 11.008 0C11.008 0 20.0595 1.40454 20.2546 1.46307L20.4887 1.50208L21.9907 3.64791V3.882C22.1858 12.3483 19.2597 17.1666 16.7822 19.7026C14.0902 22.4727 11.2616 23.253 11.008 23.253ZM1.52732 4.17461C1.33225 18.103 9.66197 21.2632 11.0275 21.6924C12.432 21.2632 20.7032 18.0835 20.5277 4.11609L19.6108 2.80909C18.5964 2.575 14.5974 1.59962 11.047 1.50208C7.49663 1.59962 3.55611 2.575 2.48319 2.80909L1.52732 4.17461Z" fill="#01426A"></path><path d="M15.4373 10.1635H7.26367V11.7631H15.4373V10.1635Z" fill="#01426A"></path><path d="M15.4373 14.2015H7.26367V15.8011H15.4373V14.2015Z" fill="#01426A"></path><path d="M15.4373 6.12537H7.26367V7.72499H15.4373V6.12537Z" fill="#01426A"></path><path d="M7.22336 12.4068C6.44306 12.4068 5.7603 11.724 5.7603 10.9047C5.7603 10.1244 6.38454 9.40264 7.22336 9.40264H11.0664V8.29071H7.16484C5.70177 8.29071 4.58984 9.46116 4.58984 10.9242C4.58984 12.3873 5.7603 13.5577 7.16484 13.5577H11.0664V12.4068H7.22336Z" fill="#42C31D"></path></svg>
                                                    <a href={product.offerManagementPage} target="_blank" >Manage</a> </>}




                                                </TableCell>
                                                <TableCell>  {product.sellerName}    </TableCell>
                                                {/* <TableCell>   <div className="dropdown">
                    <button className="btn btn-link dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <svg width="22" height="6" viewBox="0 0 22 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="3" cy="3" r="3" fill="#C4C4C4" />
                            <circle cx="11" cy="3" r="3" fill="#C4C4C4" />
                            <circle cx="19" cy="3" r="3" fill="#C4C4C4" />
                        </svg>
                    </button>
                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                        <Link className="dropdown-item" to={`/edit-post-new-listing/${product._id}`}>Edit</Link>
                        <button className="dropdown-item" onClick={() => { deleteProduct(product._id) }}>Delete</button>
                        <button className="dropdown-item" onClick={() => { toggleShareModal(true); setShareUrl(`${process.env.REACT_APP_URL}/product-details?productId=${product._id}`); setSharedCode(product.shareCode) }}>Share</button>
                    </div>
                </div>   </TableCell> */}
                                            </TableRow>)
                                    })}
                                </TableBody>
                            </Table>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 15, 20, 25, 50, 100]}
                                component="div"
                                count={data.rows ? data.rows.filter(product => product.title.toLowerCase().includes(search.toLowerCase()) || (product.sellerName && product.sellerName.toLowerCase().includes(search.toLowerCase())) || product.buyNowPrice.toString().includes(search.toLowerCase()) || product.minimumOfferPrice.toString().includes(search.toLowerCase())).length : 0}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                            />

















                            {/* 
                            <tr>
                                <td>
                                    <div className="custom-control custom-checkbox">
                                        <input type="checkbox" className="custom-control-input" id="customCheck3" />
                                        <label className="custom-control-label" for="customCheck3">John Deere S680</label>
                                    </div>
                                </td>
                                <td>Machinery</td>
                                <td>Harvesting
                                    & Headers</td>
                                <td>$50</td>
                                <td>20,000</td>
                                <td>12</td>
                                <td><button className="btn ExpiredBtn">Expired</button></td>
                                <td>Seller Name <span>seller@domain.com</span></td>
                                <td><div className="dropdown">
                                    <button className="btn btn-link dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <svg width="22" height="6" viewBox="0 0 22 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="3" cy="3" r="3" fill="#C4C4C4" />
                                            <circle cx="11" cy="3" r="3" fill="#C4C4C4" />
                                            <circle cx="19" cy="3" r="3" fill="#C4C4C4" />
                                        </svg>
                                    </button>
                                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                        <Link className="dropdown-item" to={window.location.pathname}>Action</Link>
                                        <Link className="dropdown-item" to={window.location.pathname}>Another action</Link>
                                        <Link className="dropdown-item" to={window.location.pathname}>Something else here</Link>
                                    </div>
                                </div></td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="custom-control custom-checkbox">
                                        <input type="checkbox" className="custom-control-input" id="customCheck4" />
                                        <label className="custom-control-label" for="customCheck4">John Deere S680</label>
                                    </div>
                                </td>
                                <td>Machinery</td>
                                <td>Harvesting
                                    & Headers</td>
                                <td>$50</td>
                                <td>20,000</td>
                                <td>12</td>
                                <td><button className="btn biddingBtn">Bidding</button></td>
                                <td>Seller Name <span>seller@domain.com</span></td>
                                <td><div className="dropdown">
                                    <button className="btn btn-link dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <svg width="22" height="6" viewBox="0 0 22 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="3" cy="3" r="3" fill="#C4C4C4" />
                                            <circle cx="11" cy="3" r="3" fill="#C4C4C4" />
                                            <circle cx="19" cy="3" r="3" fill="#C4C4C4" />
                                        </svg>
                                    </button>
                                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                        <Link className="dropdown-item" to={window.location.pathname}>Action</Link>
                                        <Link className="dropdown-item" to={window.location.pathname}>Another action</Link>
                                        <Link className="dropdown-item" to={window.location.pathname}>Something else here</Link>
                                    </div>
                                </div></td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="custom-control custom-checkbox">
                                        <input type="checkbox" className="custom-control-input" id="customCheck5" checked />
                                        <label className="custom-control-label" for="customCheck5">John Deere S680</label>
                                    </div>
                                </td>
                                <td>Machinery</td>
                                <td>Harvesting
                                    & Headers</td>
                                <td>$50</td>
                                <td>20,000</td>
                                <td>12</td>
                                <td><button className="btn listedBtn">Listed</button></td>
                                <td>Seller Name <span>seller@domain.com</span></td>
                                <td><div className="dropdown">
                                    <button className="btn btn-link dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <svg width="22" height="6" viewBox="0 0 22 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="3" cy="3" r="3" fill="#C4C4C4" />
                                            <circle cx="11" cy="3" r="3" fill="#C4C4C4" />
                                            <circle cx="19" cy="3" r="3" fill="#C4C4C4" />
                                        </svg>
                                    </button>
                                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                        <Link className="dropdown-item" to={window.location.pathname}>Action</Link>
                                        <Link className="dropdown-item" to={window.location.pathname}>Another action</Link>
                                        <Link className="dropdown-item" to={window.location.pathname}>Something else here</Link>
                                    </div>
                                </div></td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="custom-control custom-checkbox">
                                        <input type="checkbox" className="custom-control-input" id="customCheck7" />
                                        <label className="custom-control-label" for="customCheck7">John Deere S680</label>
                                    </div>
                                </td>
                                <td>Machinery</td>
                                <td>Harvesting
                                    & Headers</td>
                                <td>$50</td>
                                <td>20,000</td>
                                <td>12</td>
                                <td><button className="btn soldBtn">sold</button></td>
                                <td>Seller Name <span>seller@domain.com</span></td>
                                <td><div className="dropdown">
                                    <button className="btn btn-link dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <svg width="22" height="6" viewBox="0 0 22 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="3" cy="3" r="3" fill="#C4C4C4" />
                                            <circle cx="11" cy="3" r="3" fill="#C4C4C4" />
                                            <circle cx="19" cy="3" r="3" fill="#C4C4C4" />
                                        </svg>
                                    </button>
                                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                        <Link className="dropdown-item" to={window.location.pathname}>Action</Link>
                                        <Link className="dropdown-item" to={window.location.pathname}>Another action</Link>
                                        <Link className="dropdown-item" to={window.location.pathname}>Something else here</Link>
                                    </div>
                                </div></td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="custom-control custom-checkbox">
                                        <input type="checkbox" className="custom-control-input" id="customCheck8" />
                                        <label className="custom-control-label" for="customCheck8">John Deere S680</label>
                                    </div>
                                </td>
                                <td>Machinery</td>
                                <td>Harvesting
                                    & Headers</td>
                                <td>$50</td>
                                <td>20,000</td>
                                <td>12</td>
                                <td><button className="btn soldBtn">sold</button></td>
                                <td>Seller Name <span>seller@domain.com</span></td>
                                <td><div className="dropdown">
                                    <button className="btn btn-link dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <svg width="22" height="6" viewBox="0 0 22 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="3" cy="3" r="3" fill="#C4C4C4" />
                                            <circle cx="11" cy="3" r="3" fill="#C4C4C4" />
                                            <circle cx="19" cy="3" r="3" fill="#C4C4C4" />
                                        </svg>
                                    </button>
                                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                        <Link className="dropdown-item" to={window.location.pathname}>Action</Link>
                                        <Link className="dropdown-item" to={window.location.pathname}>Another action</Link>
                                        <Link className="dropdown-item" to={window.location.pathname}>Something else here</Link>
                                    </div>
                                </div></td>
                            </tr>
                      
                       */}

                        </table>
                    </div>


                    {/* <div className="tableArrowScrollar">
                        <ul className="d-flex align-items-center justify-content-end">
                            <li className="mr-4">
                                <button className="border-0 btn-link"><svg width="26" height="22" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M24 11H2" stroke="#C4C4C4" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M11 2L2 11L11 20" stroke="#C4C4C4" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                </button>
                            </li>
                            <li>
                                <button className="border-0 btn-link">
                                    <svg width="26" height="22" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2 11H24" stroke="#FF7E06" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M15 2L24 11L15 20" stroke="#FF7E06" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>


                                </button>
                            </li>
                        </ul>
                    </div> */}
                </div>
            </div>
        </>
    );
}

export default MyBiddingListing;